import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AuthProvider } from './contexts/AuthProvider'
import './styles/app.css'

const queryClient = new QueryClient({
  defaultOptions: {
    // Un 4xx no se arregla reintentando; un corte de red, a veces sí (una vez).
    queries: { retry: (fallas, error: unknown) => fallas < 1 && !(error as { response?: unknown })?.response },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
